<template>
  <v-dialog v-model="dOpenComponente" persistent full-width>
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{dInformeComponente.nombre}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form v-model="dValid" ref="form" lazy-dValidation v-if="!dSeleccionFiltro">
        <v-card-text>
          <div class="subheading font-weight-bold mt-2 mb-2 px-3">{{dInformeComponente.descripcion}}</div>
        </v-card-text>
        <v-flex>
          <v-layout row wrap>
            <v-flex text-xs-center class="mb-3">
              <v-btn class="datSecondaryBtn" small flat tile v-for="(value,index) in dBtns" :key="index" @click="fSeleccionarFiltro(value,index)">{{value.btnText}}</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-form>
      <v-form v-else>
        <ShpFiltroRecogidasEntradas :pFiltro="dFiltroSelect" :pInformeComponente="pInformeComponente" :pLimitDate="pLimitDate" @cerrar="fVolverAtras()" @alert="fAlert"></ShpFiltroRecogidasEntradas>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import ShpFiltroRecogidasEntradas from '@/components/Informes/EstadoRecogidas/ShpFiltroRecogidasEntradas'
export default {
  data () {
    return {
      dOpenComponente: true,
      dInformeComponente: null,
      dValid: true,
      dSeleccionFiltro: false,
      dFiltroSelect: null,
      dBtns: {
        recogidas: {
          'description': this.$t('recogidasDesc'),
          'btnText': this.$t('recogidasBtn'),
          'tipo': 'recogidas',
          'filtro': 'R'
        },
        entregas: {
          'description': this.$t('entregasDesc'),
          'btnText': this.$t('entregasBtn'),
          'tipo': 'entregas',
          'filtro': 'E'
        },
        pedidos: {
          'description': this.$t('pedidosDesc'),
          'btnText': this.$t('pedidosBtn'),
          'tipo': 'pedidos',
          'filtro': 'P'
        },
        todas: {
          'description': this.$t('transitosDesc'),
          'btnText': this.$t('transitosBtn'),
          'tipo': 'transacion',
          'filtro': 'T'
        }
      }
    }
  },
  components: {
    ShpFiltroRecogidasEntradas
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: true
    }
  },
  created () {
    this.dInformeComponente = this.pInformeComponente
  },
  methods: {
    fCerrarVentana () {
      this.$emit('close')
    },
    fSeleccionarFiltro (value, indice) {
      this.dSeleccionFiltro = true
      this.dFiltroSelect = value
    },
    fVolverAtras () {
      this.dSeleccionFiltro = false
      this.dFiltroSelect = null
    },
    fAlert (msg) {
      this.$emit('alert', msg)
    }
  },
  watch: {
    // control cambio informe
    pInformeComponente: {
      handler () {
        // si cambia de informe
        this.dInformeComponente = this.pInformeComponente
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/EstadoRecogidas/ShpFiltroEstadoRecogidas.vue